// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"0d286ac8fd084d34","777":"503cc14dde89cfb4"}[chunkId] + ".js";
};